import axios from 'axios';
import moment from 'moment';
import getEnv from '@/utils/env'

var getTimezoneUser = moment().format("Z")
export default axios.create({
  baseURL: getEnv('VUE_APP_API_URL'),
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'utcOffset': getTimezoneUser
  }
})
 